import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '../ui/dialog';
import { Button } from '../ui/button';
import { PlayerNewsPanel } from './PlayerNewsPanel';

interface NewsResultsDialogProps {
  playerId: string;
  playerName?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const NewsResultsDialog: React.FC<NewsResultsDialogProps> = ({
  playerId,
  playerName,
  isOpen,
  onClose
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {playerName || 'Player'} News
          </DialogTitle>
        </DialogHeader>

        <PlayerNewsPanel 
          playerId={playerId} 
          playerName={playerName} 
        />

        <DialogFooter>
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};